import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

import { ServiceCollectionProvisioningAppIcons } from './service-collection-provisioning-app-icons';

type ServiceCollectionProvisioningAnimationProps = {
	disableAnimation?: boolean;
	testId?: string;
};

export const ServiceCollectionProvisioningAnimation = ({
	disableAnimation = false,
	testId,
}: ServiceCollectionProvisioningAnimationProps) => (
	<div
		css={containerCss}
		data-testid={testId}
		data-reduced-motion={disableAnimation}
		aria-hidden="true"
	>
		<BackgroundGrid />
		<ServiceCollectionProvisioningAppIcons disableAnimation={disableAnimation} />
	</div>
);

const containerCss = css({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gridTemplateRows: '1fr',
	placeItems: 'center',
});

const svgCss = css({
	gridArea: '1 / 1',
});

const BackgroundGrid = () => (
	<svg width="337" height="396" fill="none" css={svgCss}>
		<mask id="a" width="270" height="312" x="38" y="46" maskUnits="userSpaceOnUse">
			<path
				fill={wacToken('color.extended.blue200')}
				d="m238.71 46.148 69.024 257.938-200.216 53.717L38.493 99.865 238.71 46.148Z"
				opacity=".5"
			/>
		</mask>
		<g stroke={wacToken('color.primary.saffron')} strokeWidth=".948" mask="url(#a)">
			<path d="M250.586 72.017h-459.935M250.586 107.373h-459.935M250.586 142.732h-459.935M250.586 178.091h-459.935M250.586 213.451h-459.935M250.586 248.806h-459.935M248.687 284.166h-456.142M251.531 319.525h-461.832M248.687 354.884h-456.142M230.966-264V837M195.607-264V837M160.248-264V837M124.888-264V837M89.529-264V837M54.177-264V837M706.469 72.017H246.533M706.469 107.373H246.533M706.469 142.732H246.533M706.469 178.091H246.533M706.469 213.451H246.533M706.469 248.806H246.533M704.57 284.166H248.428M707.414 319.525H245.582M704.57 354.884H248.428M298.904-264V837M263.552-264V837" />
		</g>
	</svg>
);
